(function() { window.GUID_1634010c_0758_484a_8c72_ed391edc5c13 = { getGuid: function() { return "1634010c-0758-484a-8c72-ed391edc5c13"; } }; })();
var CompuSport;
(function (CompuSport) {
    let DOM;
    (function (DOM) {
        DOM.doc = $(document);
        DOM.win = $(window);
        DOM.html = $("html");
        DOM.body = $("body");
        DOM.masterBody = $("#MasterBody").length == 0 ? $(".MasterPageBody") : $("#MasterBody");
        DOM.meta = $("meta");
        DOM.Navigating = false;
        DOM.navLoadingIndicator = $("#NavLoadingIndicator");
    })(DOM = CompuSport.DOM || (CompuSport.DOM = {}));
    function trigger(type, fn) {
        return CompuSport.DOM.body.trigger(type, fn);
    }
    CompuSport.trigger = trigger;
    function on(type, selectorOrFn, fn) {
        if (typeof fn != "undefined") {
            return CompuSport.DOM.body.on(type, selectorOrFn, fn);
        }
        else {
            return CompuSport.DOM.body.on(type, selectorOrFn);
        }
    }
    CompuSport.on = on;
    function off(event, selector, handler) {
        return CompuSport.DOM.body.off(event, selector, handler);
    }
    CompuSport.off = off;
    function DownloadFile(url, callback) {
        var hiddenIFrameID = "hiddenDownloader"; /*+ count++*/
        var iframe = document.createElement("iframe");
        iframe.id = hiddenIFrameID;
        iframe.style.display = "none";
        document.body.appendChild(iframe);
        iframe.src = url;
        if (callback != null) {
            callback();
        }
    }
    CompuSport.DownloadFile = DownloadFile;
    let isDebug = null;
    function IsDebug() {
        if (isDebug != null) {
            return isDebug;
        }
        let bodyClasses = DOM.body[0].className;
        isDebug = bodyClasses.indexOf("DEBUG") > -1;
        return isDebug;
    }
    CompuSport.IsDebug = IsDebug;
    function FetchAndPrependToTarget(props) {
        const { url, targetSelector } = props;
        if (!url || !targetSelector)
            return Promise.resolve();
        const $target = $(targetSelector);
        if (!$target.length)
            return Promise.resolve();
        return fetch(url)
            .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
        })
            .then((responseText) => {
            const $response = $(responseText);
            $target.prepend($response);
        })
            .catch((error) => {
            console.error("Error fetching:", error);
            throw error;
        });
    }
    CompuSport.FetchAndPrependToTarget = FetchAndPrependToTarget;
    function GenerateRandomId(length = 36) {
        var result = "";
        var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            if (i == 0) {
                // First character must be a letter (upper or lower case)
                // to avoid problems with jQuery selectors
                result += characters.charAt(Math.floor(Math.random() * 52));
                continue;
            }
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }
    CompuSport.GenerateRandomId = GenerateRandomId;
    function decodeHTMLEntities(text) {
        const textArea = document.createElement("textarea");
        textArea.innerHTML = text;
        return textArea.value;
    }
    CompuSport.decodeHTMLEntities = decodeHTMLEntities;
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=CompuSport.js.map
